import React, { useState } from 'react';
import { Game } from '../mergeComp';
import './startscreen.css';
import { Typography } from '@mui/material';
export function Startscreen(props) {
    var _a = useState(0 || (props === null || props === void 0 ? void 0 : props.group)), group = _a[0], setGroup = _a[1];
    var _b = useState(false), start = _b[0], setStart = _b[1];
    if (!(props === null || props === void 0 ? void 0 : props.fromPage) && !start) {
        return (React.createElement(Typography, null,
            React.createElement("div", { className: "gameboard" },
                React.createElement("div", { className: "level_wrapper" },
                    React.createElement("div", { className: "text_startScreen" },
                        React.createElement("h2", null, "\u0421\u043F\u0440\u0438\u043D\u0442"),
                        React.createElement("p", null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0438\u0433\u0440\u044B.\u0427\u0435\u043C \u0432\u044B\u0448\u0435 \u0443\u0440\u043E\u0432\u0435\u043D\u044C,\u0442\u0435\u043C \u0441\u043B\u043E\u0436\u043D\u0435\u0435 \u0441\u043B\u043E\u0432\u0430!"),
                        React.createElement("p", null, "\u0414\u043B\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043C\u044B\u0448\u044C \u0438\u043B\u0438 \u043A\u043D\u043E\u043F\u043A\u0438 \u0412\u043B\u0435\u0432\u043E \u0438 \u0412\u043F\u0440\u0430\u0432\u043E"),
                        React.createElement("button", { className: "chose_level green", onClick: function () {
                                setGroup(0);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 1"),
                        React.createElement("button", { className: "chose_level blue", onClick: function () {
                                setGroup(1);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 2"),
                        React.createElement("button", { className: "chose_level yellow", onClick: function () {
                                setGroup(2);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 3"),
                        React.createElement("button", { className: "chose_level orange", onClick: function () {
                                setGroup(3);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 4"),
                        React.createElement("button", { className: "chose_level brightorange", onClick: function () {
                                setGroup(4);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 5"),
                        React.createElement("button", { className: "chose_level red", onClick: function () {
                                setGroup(5);
                                setStart(true);
                            } }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 6"))))));
    }
    else {
        return (React.createElement(Typography, { component: 'section', variant: 'body2' },
            React.createElement(Game, { group: group, page: (props === null || props === void 0 ? void 0 : props.page) === undefined ? 29 : props.page, fromPage: (props === null || props === void 0 ? void 0 : props.fromPage) || false })));
    }
}
